/**
 * Protocol Testare Modal — accordion + quicknav behavior.
 * Cooperates with the native <dialog class="modal"> for open/close
 * (driven by commandfor="protocol-testare-modal" in markup).
 * Does NOT re-implement modal open/close — only manages internal state.
 */

(function initProtocolModal() {
  const MODAL_ID = 'protocol-testare-modal';

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function getScrollContainer() {
    const modal = getModal();
    if (!modal) return null;
    return modal.querySelector('.protocol-modal__content');
  }

  // ─── Accordion toggle ─────────────────────────────────────────────────────

  function toggleCategory(headBtn) {
    const isExpanded = headBtn.getAttribute('aria-expanded') === 'true';
    const bodyId = headBtn.getAttribute('aria-controls');
    const body = document.getElementById(bodyId);
    if (!body) return;

    const newState = !isExpanded;
    headBtn.setAttribute('aria-expanded', String(newState));

    const countPill = headBtn.querySelector('.protocol-cat__count');
    if (countPill) {
      if (newState) {
        countPill.classList.remove('pill--neutral');
        countPill.classList.add('pill--green');
      } else {
        countPill.classList.remove('pill--green');
        countPill.classList.add('pill--neutral');
      }
    }

    if (newState) {
      body.removeAttribute('hidden');
    } else {
      body.setAttribute('hidden', '');
    }
  }

  function expandCategory(headBtn) {
    if (headBtn.getAttribute('aria-expanded') === 'true') return;
    toggleCategory(headBtn);
  }

  // ─── Quicknav jump ─────────────────────────────────────────────────────────

  function handleQuicknavClick(e) {
    const pill = e.target.closest('.protocol-modal__quicknav-pill');
    if (!pill) return;
    e.preventDefault();

    const href = pill.getAttribute('href');
    if (!href || !href.startsWith('#')) return;
    const targetId = href.slice(1);
    const targetSection = document.getElementById(targetId);
    if (!targetSection) return;

    const headBtn = targetSection.querySelector('.protocol-cat__head');
    if (headBtn) expandCategory(headBtn);

    const scrollEl = getScrollContainer();
    if (!scrollEl) return;

    const containerRect = scrollEl.getBoundingClientRect();
    const sectionRect = targetSection.getBoundingClientRect();
    const relativeTop = sectionRect.top - containerRect.top + scrollEl.scrollTop - 12;
    scrollEl.scrollTop = relativeTop;
  }

  // ─── Wire up ───────────────────────────────────────────────────────────────

  function wireModal(modal) {
    const content = modal.querySelector('.protocol-modal__content');
    if (content) {
      content.addEventListener('click', (e) => {
        const headBtn = e.target.closest('.protocol-cat__head');
        if (headBtn) toggleCategory(headBtn);
      });
    }

    const quicknav = modal.querySelector('.protocol-modal__quicknav');
    if (quicknav) {
      quicknav.addEventListener('click', handleQuicknavClick);
    }
  }

  function init() {
    const modal = getModal();
    if (!modal) return;
    wireModal(modal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
